/**
 * This is used to define mutation types enum.
 * 
 * Mutations are used for synchronous state management.
 */
export enum MutationType {
  // login and user 
  AUTH_USER = 'AUTH_USER',
  ROOMS = 'ROOMS',
  SELECT_ROOM = 'SELECT_ROOM',
  SELECT_GAME_KIND = 'SELECT_GAME_KIND',
  USER_CONNECTED = 'USER_CONNECTED',
  ENTER_ROOM = 'ENTER_ROOM',

  // main game windows
  LOGIN_SHOWN = 'LOGIN_SHOWN',
  ROOMS_SHOWN = 'ROOMS_SHOWN',
  SETTINGS_SHOWN = 'SETTINGS_SHOWN',
  HELP_SHOWN = 'HELP_SHOWN',

  // chat and room panel
  PLAYER_LIST = 'PLAYER_LIST',
  USER_ADDED = 'USER_ADDED',
  USER_REMOVED = 'USER_REMOVED',
  USER_UPDATED = 'USER_UPDATED',
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  GAME_MESSAGE = 'GAME_MESSAGE',
  CHAT_CLEAR = 'CHAT_CLEAR',

  // game invite modal
  INVITATION_REQUEST_MODAL = 'INVITATION_REQUEST_MODAL',
  INVITATION_REQUEST_GAME = 'INVITATION_REQUEST_GAME',
  INVITATION_REQUEST_TXT = 'INVITATION_REQUEST_TXT',

  // info modal
  INFO_MODAL = 'INFO_MODAL',
  INFO_TXT = 'INFO_TXT',

  // wait for opponent modal
  WAIT_FOR_OPPONENT_MODAL = 'WAIT_FOR_OPPONENT_MODAL',

  // join tournament modal
  JOIN_TOURNAMENT_MODAL = 'JOIN_TOURNAMENT_MODAL',
  JOIN_TOURNAMENT_ROOM = 'JOIN_TOURNAMENT_ROOM',
  JOIN_TOURNAMENT_REG = 'JOIN_TOURNAMENT_REG',

  // game and player status
  PLAYER1 = 'PLAYER1',
  PLAYER2 = 'PLAYER2',
  PLAY_TURN = 'PLAY_TURN',

  // settings
  SETTINGS = 'SETTINGS',
}
